module.exports = __webpack_public_path__ + "static/media/hatBox.2653e1f7.svg";